import { useCvpQueryClient } from "../api/queryClient";
import { authAPI } from "../api/auth";
import { CvpLocale } from "../constants/CvpLocale";
import { redirect } from "../url/redirect";
import { useWhoAmI } from "../user/useWhoAmI";
import { getStorageArea } from "../utils/storageArea";
import { candidateAPI } from "../api/candidate";
import { getCallingCode } from "./useLocales";

const storageArea = getStorageArea("session");

/**
 * Use this function to set the locale for the user.
 * For example from a menu where the user can choose between different languages.
 *
 * Use useSetLocale to get current locale
 * */
export function useSetLocale() {
  const { confirmedLoggedIn, whoAmI } = useWhoAmI();
  const cvpQueryClient = useCvpQueryClient();

  const setLocale = async (locale: CvpLocale) => {
    if (confirmedLoggedIn) {
      // set locale for visma-connect user (affects application interface)
      await authAPI.saveLocaleChoice({
        locale,
      });

      // set locale for candidate in current concern (affects emails etc)
      if (whoAmI?.idCandidate) {
        await candidateAPI.setCandidateLanguage({
          idCandidate: whoAmI.idCandidate,
          idLanguage: getCallingCode(locale), // (idLanguage expects calling code mapping)
        });
      }
      
      storageArea.removeItem("locale");
      redirect(null, { mergeQs: { cvplocale: null } });
      cvpQueryClient.invalidateQueries();
    } else {
      // sette sessionStorage.getItem("locale")
      // fjerne cvplocale fra querystring (getRedirectProps)
      storageArea.setItem("locale", locale);
      redirect(null, { mergeQs: { cvplocale: null } });
      cvpQueryClient.invalidateQueries();
    }
  };

  return { setLocale };
}
